import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankIntegrations  {
    _originalTypeClassName = "zERP.BO.BankIntegrations";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankIntegrations.translate = translateService;
}
this.BankIntegrationsKey = null;
this._key = this.BankIntegrationsKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BankIntegrationsKey:any;
get BankIntegrationsKey(): any {
    return this._BankIntegrationsKey;
  }
set BankIntegrationsKey(value: any) {
    this._BankIntegrationsKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BankIntegrationsKey == null || $this.BankIntegrationsKey == 0;
            }


}